import { render, staticRenderFns } from "./ParcoursReport.vue?vue&type=template&id=a1a52ff6&scoped=true&"
import script from "./ParcoursReport.vue?vue&type=script&lang=js&"
export * from "./ParcoursReport.vue?vue&type=script&lang=js&"
import style0 from "./ParcoursReport.vue?vue&type=style&index=0&id=a1a52ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a52ff6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
